import { AddressInput } from "components/map/shared";
import React from "react";
import Template from "./template";

export default class AddressField extends Template {
    onSelectGeopoint = (data) => {
        const { inputProps } = this.props;
        this.props.onChange({ value: data, name: inputProps?.name });
    };

    renderField = () => {
        const tabIndex = this.context?.baseTabIndex || 0;
        const props = {
            ...this.props,
            notResponsive: true,
            resultWrap: "map__result-wrap--over",
            placeholder: "Начните вводить адрес",
            inputClass: "field-wrap__input",
            onSelectGeopoint: this.onSelectGeopoint,
            tabIndex,
        };

        return <AddressInput {...props} />;
    };
}
